/* eslint-disable no-console */
// NPM Imports
import { batch } from "react-redux";
import { debounce } from "lodash";
// Components Imports
// import { Toastr } from "../../revvComponents";

// Internal Imports
import { UNDO_REDO_STACK_LIMIT } from "../../constants/document";
import store from "../../store";
import { removeDataFromLocalStorage } from "../../utils/globalUtils";
import {
  getTableDBContent,
  getFirstComponentText,
} from "../../utils/documentUtils";

import {
  analyzeDocService,
  approvalStatusCheckService,
  approveRejectDocService,
  changeDocumentStatusService,
  createNewDocument,
  editApprovedDocumentService,
  fetchAllDocumentTypes,
  fetchClausesForDealTable,
  fetchDynamicFieldsService,
  forceApproveDocService,
  getDocActivities,
  resetDocToDraftService,
  sendDocForApprovalService,
  updateSubmitDeclineInternalService,
  updateDocumentComponentService,
  batchUpdateDocumentSection,
  uploadDocument,
  updateDocDetailsService,
  sendDocumentForSignature,
  cancleESignatureService,
  updateDocumentStatusService,
  addDocRecipientsService,
  fetchDocRecipientListService,
  docAccepAndSignService,
  docAfterAccepAndSignService,
  deleteReviewersServices,
  editReviewerPermissionServices,
  addAcceptorsService,
  acceptanceApprovalStatusCheckService,
  deleteDocumentComponentService,
  restoreDocumentComponentService,
  generatePermaLinkService,
  generateSnapLinkService,
  getPermaLinkService,
  getSnapLinkService,
  deletePermaLinkService,
  deleteSnapLinkService,
  updateDocumentField,
  updateDocumentFieldNonLoggedIn,
  updateSubmitRejectSignerFiller,
  updateDocSignatories,
  deleteDocSigner,
  authStripe,
  sendStripePaymentOnSave,
  getStripePaymentSessionId,
  getStripeUser,
  getStripePaymentDetails,
  deactivateStripe,
  getStripePaymentDetailsWithHash,
  getStripePaymentDetailsWithHashPerma,
  deleteStripeFromDocument,
  updateDocumentOrder,
  updateEmailResendService,
  updatePDFFormFieldServiceDocument,
  getMasterDocDataService,
  generateMasterDocumentService,
  disableMasterDocumentService,
  updateDocumentRecipientField,
  updateDocumentFillerType,
  createBulkDocumentService,
  uploadPDFDocument,
  getDocumentSettingsActionService,
  updatedDocumentSettingsActionService,
  addSharedDocRecipientsActionService,
  getDocSignatoriesV2,
  createDocSignatoryV2,
  createDocSignerIdentity,
  getDocSignerIdentities,
  updateDocSignerIdentity,
  deleteDocSignerIdentity,
  deleteComponentsBulk,
  updateTemplateSignerIdentity,
  deleteTemplateSignerIdentity,
  getTemplateSignerIdentities,
  createTemplateSignerIdentity,
  getTemplateSignatoriesV2,
  createTemplateSignatoryV2,
  deleteTemplateComponent,
  updateDocumentFieldCatalog,
  convertFormDoctoEditor,
} from "./services";

import {
  restoreTemplateComponentService,
  deleteTemplateComponentService,
  updateTemplateComponentService,
  updateTemplateOrder,
  uploadPDFTemplate,
  updatePDFFormFieldServiceTemplate,
  updateTemplateSignatories,
  deleteTemplateSigner,
  updateTemplateDetailsService,
} from "../DocumentTemplateActions/templateService";

import {
  prepareDocAnalysisData,
  prepareDocApprovalStatusData,
  prepareCollaboratorsData,
  removeEntityFromSection,
  validateDocForm,
  getUpdatedDynamicFieldsInSections,
  getUpdatedFormFieldsWithField,
  changeFormFieldsValue,
  updateDocSaveIndicator,
  getSignerIdentityTags,
  getUpdatedFormFieldsWithFieldCatalog,
  getUpdatedDynamicFieldsInSectionsForCatalog,
} from "./method";
import { generateDocStatusConfigs } from "../QuotationActions/QuotationMethods";
import { fetchDocumentByDocNo } from "../QuotationActions/QuotationServices";
// import { updateToolpaneView } from "../ToolbarActions/toolbarActions";

import { QuotationUtils, GlobalUtils, DocumentUtils } from "../../utils";
import { DOCUMENTS, COMMON } from "../../constants";
import { Signatory } from "../../payloadObjects/signatoryPayload";

const { DOCUMENT_MODE, DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;
const { createDocumentRevision, fillFormField } = QuotationUtils;
const { numberForamting, writeDataToLocalStorage } = GlobalUtils;
const { getContentForComponent, convertDocumentContent } = DocumentUtils;

const { DEFAULT_CURRENCY, CURRENCY_SYMBOL } = COMMON;

export const deleteSigner = mode => {
  if (mode === DOCUMENT_MODE.DOCUMENT) return deleteDocSigner;
  if (mode === DOCUMENT_MODE.TEMPLATE) return deleteTemplateSigner;
  return () => {};
};

export const updateSignatories = mode => {
  if (mode === DOCUMENT_MODE.DOCUMENT) return updateDocSignatories;
  if (mode === DOCUMENT_MODE.TEMPLATE) return updateTemplateSignatories;
  return () => {};
};

export const updatePDFFormFieldService = mode => {
  if (mode === DOCUMENT_MODE.DOCUMENT) return updatePDFFormFieldServiceDocument;
  if (mode === DOCUMENT_MODE.TEMPLATE) return updatePDFFormFieldServiceTemplate;
  return () => {};
};

export const uploadPDF = mode => {
  if (mode === DOCUMENT_MODE.DOCUMENT) return uploadPDFDocument;
  if (mode === DOCUMENT_MODE.TEMPLATE) return uploadPDFTemplate;
  return () => {};
};

export const restoreSection = mode => {
  if (mode === DOCUMENT_MODE.DOCUMENT) return restoreDocumentComponentService;
  if (mode === DOCUMENT_MODE.TEMPLATE) return restoreTemplateComponentService;
  return () => {};
};

export const deleteSection = mode => {
  if (mode === DOCUMENT_MODE.DOCUMENT) return deleteDocumentComponentService;
  if (mode === DOCUMENT_MODE.TEMPLATE) return deleteTemplateComponentService;
  return () => {};
};

export const updateSection = mode => {
  if (mode === DOCUMENT_MODE.DOCUMENT) return updateDocumentComponentService;
  if (mode === DOCUMENT_MODE.TEMPLATE) return updateTemplateComponentService;
  return () => {};
};

export const updateComponentOrder = mode => {
  if (mode === DOCUMENT_MODE.DOCUMENT) return updateDocumentOrder;
  if (mode === DOCUMENT_MODE.TEMPLATE) return updateTemplateOrder;
  return () => {};
};

export const updateDocMetaService = mode => {
  if (mode === DOCUMENT_MODE.DOCUMENT) return updateDocDetailsService;
  if (mode === DOCUMENT_MODE.TEMPLATE) return updateTemplateDetailsService;
  return () => {};
};

// upload a document to s3
export const saveDocument = (file, opp) =>
  uploadDocument(file, opp)
    .then(res => res)
    .catch(error => error);

// create document and content
export const createDocumentAndContent = document =>
  new Promise((resolve, reject) => {
    createNewDocument(document)
      .then(res => resolve(res))
      .catch(error => reject(error));
  });

// below action uses fetchDocumentByDocNo with a param - (no_content is true)
// and sends back the doc object without document/dealtable data. We'll use this to pick out
// status, isLocked and other meta data (as required) fields value and update redux
export const fetchAndUpdateDocMeta = docNo => dispatch =>
  new Promise((resolve, reject) => {
    fetchDocumentByDocNo(docNo, true)
      .then(response => {
        const {
          id: docID,
          status: docStatus,
          is_locked: docIsLocked,
          stage,
          revision_no: revisionNo,
        } = response;
        const docStatusConfigs = generateDocStatusConfigs(docStatus, stage);

        dispatch({
          type: "UPDATE_DOC_META",
          payload: {
            docID,
            docStatus,
            docIsLocked,
            docStatusConfigs,
            stage,
            revisionNo,
          },
        });

        resolve("success");
      })
      .catch(error => {
        reject(error);
      });
  });

export const tempUpdateDocMeta = payload => dispatch => {
  const { docIsLocked, stage } = payload;

  dispatch({
    type: "TEMP_UPDATE_DOC_META",
    payload: {
      docIsLocked,
      stage,
    },
  });
};

export const getClausesForDealTable = dealTableID => async dispatch => {
  try {
    const clauses = await fetchClausesForDealTable(dealTableID);
    dispatch({
      type: "UPDATE_CLAUSE_INFORMATION",
      payload: clauses,
    });
    return clauses;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllDocumentTypes = () => dispatch => {
  fetchAllDocumentTypes()
    .then(documentType => {
      dispatch({
        type: "UPDATE_DOCUMENT_TYPES",
        payload: documentType,
      });
    })
    .catch(error => error);
};

export const batchUpdateSectionInDocument = sections => dispatch => {
  dispatch({
    type: "BATCH_UPDATE_SECTION_IN_DOCUMENT",
    payload: sections,
  });
};

export const updateNoOfPagesAction = noPages => dispatch => {
  dispatch({
    type: "UPDATE_DOCUMENT_NO_PAGES",
    payload: noPages,
  });
};

export const updatePageBreakScrollViewAction = scrollToView => dispatch => {
  dispatch({
    type: "UPDATE_PAGE_BREAK_SCROLL_VIEW",
    payload: scrollToView,
  });
};

/**
 * ToolsPane Action below
 */

export const changeToolsView = view => dispatch => {
  dispatch({
    type: "UPDATE_TOOLPANE_DATA",
    payload: {
      isOpen: true,
      view,
    },
  });
};

export const updatePDFDataForSignature = data => dispatch => {
  dispatch({
    type: "SET_PDF_SECTION_DATA_SIGNATURE",
    payload: {
      data,
    },
  });
};

export const updatePDFSignerConfig = (componentID, newConfig) => dispatch => {
  dispatch({
    type: "UPDATE_PDF_SIGNER_CONFIG",
    payload: {
      componentID,
      newConfig,
    },
  });
};

/**
 * ToolsPane Action above
 */

/**
 * DocApproval/WorkFlow Action below
 */

export const analyzeDoc = (payload, triggeredFrom) => dispatch =>
  new Promise((resolve, reject) => {
    analyzeDocService(payload)
      .then(response => {
        dispatch({
          type: "DOC_ANALYSIS",
          payload: {
            docAnalysis: prepareDocAnalysisData(response.Analysis),
            triggeredFrom,
          },
        });
        resolve(response);
      })
      .catch(error => {
        console.debug("docActions =>", error);
        reject(error);
      });
  });

export const sendDocForApproval = payload => () =>
  new Promise((resolve, reject) => {
    sendDocForApprovalService(payload)
      .then(response => {
        console.debug(response);
        resolve("success");
      })
      .catch(error => {
        console.debug("docActions =>", error);
        reject(error);
      });
  });

export const approvalStatusCheck = (docID, status) => dispatch =>
  new Promise((resolve, reject) => {
    approvalStatusCheckService(docID, status)
      .then(response => {
        const { approvalStatusData, pendingApprovers, docAllApprovers } =
          prepareDocApprovalStatusData(response.Approvals);
        const payload = {
          approvalStatusData,
          pendingApprovers,
          docAllApprovers,
          collaboratorsData: prepareCollaboratorsData(response.Approvals),
          pendingApprovalRequired: response.Response_Required,
        };
        dispatch({
          type: "DOC_APPROVAL_STATUS",
          payload,
        });
        resolve("success");
      })
      .catch(error => {
        console.debug("docActions =>", error);
        reject(error);
      });
  });

export const approveRejectDoc = (docID, payload, isApproved) => () =>
  new Promise((resolve, reject) => {
    approveRejectDocService(docID, payload, isApproved)
      .then(() => {
        resolve("success");
      })
      .catch(error => {
        console.debug("docActions =>", error);
        reject(error);
      });
  });

export const resetDocToDraft = docID => () =>
  new Promise((resolve, reject) => {
    resetDocToDraftService(docID)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const forceApproveDoc = docID => () =>
  new Promise((resolve, reject) => {
    forceApproveDocService(docID)
      .then(() => {
        resolve("success");
      })
      .catch(error => {
        reject(error);
      });
  });

export const documentStatus = (docID, changedStatus) => () =>
  new Promise((resolve, reject) => {
    changeDocumentStatusService(docID, changedStatus)
      .then(() => {
        resolve("success");
      })
      .catch(error => {
        console.error("docActions =>", error);
        reject(error);
      });
  });

/**
 * DocApproval/WorkFlow Action above
 */

export const updateHoveredDocumentSectionId =
  (sectionID, updateAfterSection) => dispatch => {
    dispatch({
      type: "UPDATE_HOVERED_DOCUMENT_SECTION_ID",
      payload: { sectionID, updateAfterSection },
    });
  };

export const makeSendForSignatureButton = data => dispatch => {
  const { status, stage } = data;
  const docStatusConfigs = generateDocStatusConfigs(status, stage);
  const payload = {
    docStatusConfigs,
    status,
    stage,
  };
  dispatch({
    type: "UPDATE_SEND_FOR_SIGNATURE_BUTTON_STATUS",
    payload,
  });
};

export const addSharedDocRecipientsAction =
  (docId, sharinghash, data) => dispatch =>
    new Promise((resolve, reject) => {
      addSharedDocRecipientsActionService(docId, sharinghash, data)
        .then(response => {
          dispatch({
            type: "UPDATE_DOC_ADD_RECIPIENTS",
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });

export const addDocRecipientsAction =
  (docId, data, flag, autoSignersList) => dispatch =>
    new Promise((resolve, reject) => {
      // for the new fillers part
      const {
        document: { showForm },
      } = store.getState().DocumentStore;
      let newData = data;
      if (showForm) {
        newData = { ...newData, fillers: data.fillers };
      } else if (newData.fillers) {
        delete newData.fillers;
      }
      addDocRecipientsService(docId, newData)
        .then(response => {
          let docRecipients = [];
          let isAutoSigner = false;
          const {
            collaborators,
            signers,
            last_email_sent_at: lastEmailSentAt,
          } = response;
          if (
            (collaborators && collaborators.length > 0) ||
            (signers && signers.length > 0)
          ) {
            docRecipients = [...collaborators, ...signers];
          }
          if (signers && signers.length === 1) {
            isAutoSigner =
              Array.isArray(autoSignersList) && autoSignersList.length > 0
                ? autoSignersList.includes(signers[0].user.user_email)
                : false;
          }
          const {
            document: { stage },
          } = store.getState().DocumentStore;
          let tempStage = stage;
          // let showSignIframe = false;
          let isSentForSignature = false;
          let documentFlow = "ACCEPTANCE";
          if (
            flag === "isReview" &&
            response.signers &&
            response.signers.length > 0
          ) {
            isSentForSignature = true;
            documentFlow = "ESIGN";
          }
          if (
            flag === "isSigner" &&
            response.signers &&
            response.signers.length > 0
          ) {
            isSentForSignature = true;
            documentFlow = "ESIGN";
            if (showForm && data.fillers && data.fillers.length) {
              tempStage = "SENT_FOR_FILLING";
            } else if (isAutoSigner) {
              tempStage = "COMPLETED";
            } else {
              tempStage = "SENT";
            }

            // showSignIframe = false;
          }
          const payload = {
            // iframeUrl: response.tagging_view_url || "",
            // iframeUrl: "",
            // envelopeID: response.envelopeId,
            envelopeID: "",
            stage: tempStage,
            isSentForSignature,
            docRecipients,
            lastEmailSentAt,
            documentFlow,
            // showSignIframe,
          };

          dispatch({
            type: "UPDATE_DOC_STAGE_AFTER_ADD_RECIPIENTS",
            payload,
          });

          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
export const addAcceptorsDetailsAction = (docId, data) => dispatch =>
  new Promise((resolve, reject) => {
    addAcceptorsService(docId, data)
      .then(res => {
        let docRecipients = [];
        let docApprovalPending = "";
        const {
          document: { stage },
        } = store.getState().DocumentStore;
        let tempStage = stage;
        if (res && res.length > 0) {
          docRecipients = [...res];
          const newRes = res.some(item => item.recipient_type === "FILLER");
          if (newRes) {
            tempStage = "SENT_FOR_FILLING";
          } else {
            tempStage = "SENT";
          }
          docApprovalPending = res.is_acceptor;
        }
        const payload = {
          docRecipients,
          docId,
          docApprovalPending,
          stage: tempStage,
          documentFlow: "ACCEPTANCE",
        };
        dispatch({
          type: "ADD_ACCEPTORS",
          payload,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const fetchDocRecipientListAction = docId => dispatch =>
  new Promise((resolve, reject) => {
    fetchDocRecipientListService(docId)
      .then(response => {
        let data = [];
        let acceptData = [];
        let lastEmailSentAt;
        if (response) {
          const {
            collaborators,
            signers,
            acceptors,
            // eslint-disable-next-line camelcase
            last_email_sent_at,
          } = response;
          if (
            (collaborators && collaborators.length > 0) ||
            (signers && signers.length > 0) ||
            (acceptors && acceptors.length > 0)
          ) {
            data = [...collaborators, ...signers, ...acceptors];
          }
          if (acceptors && acceptors.length > 0) {
            acceptData = [...acceptors];
          }
          // eslint-disable-next-line camelcase
          lastEmailSentAt = last_email_sent_at;
        }
        dispatch({
          type: "FETCH_DOC_RECIPIENT_LIST",
          payload: { data, acceptData, lastEmailSentAt },
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const removeQuotetableData = () => dispatch => {
  dispatch({
    type: "NUKE_QUOTETABLE_DATA",
  });
};

export const removeGoogleSheetData = sectionID => dispatch => {
  dispatch({
    type: "REMOVE_GOOGLESHEET_DATA",
    payload: sectionID,
  });
};

export const addComponentInDocument =
  (newSectionList, newSection, headerFooterType) => dispatch => {
    dispatch({
      type: "ADD_COMPONENT_IN_DOCUMENT",
      payload: {
        newSectionList,
        newSection,
        headerFooterType,
      },
    });
  };

// New method
export const addDocumentComponentAction =
  (
    layout,
    newComponent,
    dbRowIndex,
    dbColIndex,
    headerFooterType,
    shouldNotActivateComponent,
    activeEditorPayload,
  ) =>
  dispatch => {
    dispatch({
      type: "ADD_DOCUMENT_COMPONENT",
      payload: {
        layout,
        newComponent,
        headerFooterType,
        dbRowIndex,
        dbColIndex,
        shouldNotActivateComponent,
        activeEditorPayload,
      },
    });

    if (newComponent && newComponent.type === "StripePayment") {
      dispatch({
        type: "UPDATE_TOOLPANE_DATA_FOR_STRIPE_PAYMENT",
        payload: {
          sectionData: newComponent,
        },
      });
    }
  };

export const deleteDocumentComponentAction =
  (componentID, component) => dispatch => {
    if (component) {
      if (component.deleteDealTable && component.dealTableId)
        store.dispatch(removeQuotetableData());
      if (component.removeGoogleSheet)
        store.dispatch(removeGoogleSheetData(componentID));

      // update the field mapping list
      const { fieldDiffList: { deleted = [] } = {} } = component;
      let newMapping = null;
      if (Array.isArray(deleted) && deleted.length > 0) {
        const { TemplateStore } = store.getState();
        const { fieldSectionMapping } = TemplateStore;
        const sectionID = component.section_id || component.id;
        newMapping = {
          ...fieldSectionMapping,
        };
        deleted.forEach(fieldID => {
          if (Array.isArray(fieldSectionMapping[fieldID])) {
            const idList = fieldSectionMapping[fieldID].filter(
              id => id !== sectionID,
            );
            if (idList.length > 0) {
              newMapping[fieldID] = idList;
            } else {
              delete newMapping[fieldID];
            }
          }
        });
      }
      if (newMapping) {
        // eslint-disable-next-line no-use-before-define
        store.dispatch(updateFieldSectionMapping(newMapping));
      }
    }
    dispatch({
      type: "DELETE_DOCUMENT_COMPONENT",
      payload: componentID,
    });
    if (
      component &&
      (component.type === "HTML" || component.type === "Table")
    ) {
      dispatch({
        type: "NUKE_ACTIVE_EDITOR",
      });
    }
  };

export const updateComponentsDBRowColIndexesAction =
  newComponents => dispatch => {
    dispatch({
      type: "UPDATE_COMPONENTS_DB_ROW_COL_INDEXES",
      payload: { newComponents },
    });
  };

export const forceRerenderWhenClauseOptionsUpdate = payload => dispatch => {
  dispatch({
    type: "FORCE_RERENDER_WHEN_CLAUSE_OPTIONS_UPDATE",
    payload,
  });
};

const updateUsedFormFields = updatedList => dispatch =>
  dispatch({
    type: "UPDATE_USED_FORM_FIELD",
    payload: updatedList,
  });

const updateTemplateUsedFormFields = updatedList => dispatch =>
  dispatch({
    type: "UPDATE_TEMPLATE_USED_FORM_FIELD",
    payload: updatedList,
  });

export const updateDocumentComponentAction =
  (
    component,
    newlyAddedComponent, // It is being used for adding components in coverpage & header/footer
  ) =>
  dispatch => {
    const { fieldDiffList: { added = [], deleted = [] } = {} } = component;
    let newMapping = null;
    let deletedFieldList = [];
    const reduxState = store.getState();
    const {
      fieldSectionMapping,
      template: { fields_used },
    } = reduxState.TemplateStore;
    let updatedFieldsUsed = [];
    if (
      (Array.isArray(added) && added.length > 0) ||
      (Array.isArray(deleted) && deleted.length > 0)
    ) {
      const sectionID = component.section_id || component.id;
      newMapping = {
        ...fieldSectionMapping,
      };
      added.forEach(fieldID => {
        if (
          fieldID in fieldSectionMapping &&
          Array.isArray(fieldSectionMapping[fieldID])
        ) {
          const idList = fieldSectionMapping[fieldID];
          if (!idList.includes(sectionID)) {
            idList.push(sectionID);
          }
          newMapping[fieldID] = idList;
        } else {
          newMapping[fieldID] = [sectionID];
        }
      });
      deleted.forEach(fieldID => {
        if (Array.isArray(fieldSectionMapping[fieldID])) {
          const idList = fieldSectionMapping[fieldID].filter(
            id => id !== sectionID,
          );
          if (idList.length > 0) {
            newMapping[fieldID] = idList;
          } else {
            delete newMapping[fieldID];
          }
        }
        updatedFieldsUsed = fields_used.map(field => {
          if (
            field.conditional_logic &&
            field.conditional_logic.parent_id === fieldID
          ) {
            const tempObj = { ...field };
            delete tempObj.conditional_logic;
            return tempObj;
          }
          return field;
        });
      });
      const deletedMappingLength =
        Array.isArray(deleted) && deleted.length > 0
          ? fieldSectionMapping[deleted[0]]
          : [];
      if (
        Array.isArray(deletedMappingLength) &&
        deletedMappingLength.length === 1
      ) {
        deletedFieldList =
          Array.isArray(deleted) && deleted.length > 0
            ? updatedFieldsUsed.filter(fields => fields.id !== deleted[0])
            : [];
      }
    }
    if (updatedFieldsUsed && updatedFieldsUsed.length > 0) {
      dispatch(updateTemplateUsedFormFields(updatedFieldsUsed));
    }
    dispatch({
      type: "UPDATE_DOCUMENT_COMPONENT",
      payload: {
        component,
        newlyAddedComponent,
        fieldSectionMapping: newMapping,
        deletedFieldList,
      },
    });
  };

export const toggleComponentLockUnlock = data => dispatch => {
  const { DocumentStore } = store.getState();
  const { components } = DocumentStore;

  let newComponent = null;
  if (data) {
    if (data.isBodyView) {
      if (components[data.activeComponentID]) {
        newComponent = {
          ...components[data.activeComponentID].content,
          lock: data.lockStatus,
        };
      }
    } else if (data.isCoverPageView) {
      let coverpage = null;
      if (components[data.coverPageComponentId]) {
        coverpage = { ...components[data.coverPageComponentId] };
      }
      if (coverpage) {
        coverpage = {
          ...coverpage.content,
          data: {
            ...coverpage.content.data,
            components: {
              ...coverpage.content.data.components,
              [data.activeComponentID]: {
                ...coverpage.content.data.components[data.activeComponentID],
                content: {
                  ...coverpage.content.data.components[data.activeComponentID]
                    .content,
                  lock: data.lockStatus,
                },
              },
            },
          },
        };
        newComponent = coverpage;
      }
    } else if (data.isHeaderView) {
      let headerComponent = null;
      if (components[data.headerComponentID]) {
        headerComponent = { ...components[data.headerComponentID] };
      }
      if (headerComponent) {
        headerComponent = {
          ...headerComponent.content,
          data: {
            ...headerComponent.content.data,
            header: {
              ...headerComponent.content.data.header,
              components: {
                ...headerComponent.content.data.header.components,
                [data.activeComponentID]: {
                  ...headerComponent.content.data.header.components[
                    data.activeComponentID
                  ],
                  content: {
                    ...headerComponent.content.data.header.components[
                      data.activeComponentID
                    ].content,
                    lock: data.lockStatus,
                  },
                },
              },
            },
          },
        };
        newComponent = headerComponent;
      }
    } else if (data.isFooterView) {
      let footerComponent = null;
      if (components[data.footerComponentID]) {
        footerComponent = { ...components[data.footerComponentID] };
      }
      if (footerComponent) {
        footerComponent = {
          ...footerComponent.content,
          data: {
            ...footerComponent.content.data,
            footer: {
              ...footerComponent.content.data.footer,
              components: {
                ...footerComponent.content.data.footer.components,
                [data.activeComponentID]: {
                  ...footerComponent.content.data.footer.components[
                    data.activeComponentID
                  ],
                  content: {
                    ...footerComponent.content.data.footer.components[
                      data.activeComponentID
                    ].content,
                    lock: data.lockStatus,
                  },
                },
              },
            },
          },
        };
        newComponent = footerComponent;
      }
    }
  }
  dispatch({
    type: "TOGGLE_COMPONENT_LOCK_UNLOCK",
    payload: {
      component: newComponent,
      activeComponentID: data.activeComponentID,
      activeComponentType: data.activeComponentType,
    },
  });
  setTimeout(() => {
    updateSection(DOCUMENT_MODE.TEMPLATE)(newComponent)
      .then(() => {})
      .catch(error => {
        console.error("error", error);
        if (data.oldSection) {
          dispatch({
            type: "TOGGLE_COMPONENT_LOCK_UNLOCK",
            payload: {
              component: data.oldSection,
              activeComponentID: data.activeComponentID,
              activeComponentType: data.activeComponentType,
            },
          });
        }
      });
  }, 500);
};

export const removeComponentInDocument =
  (sectionID, nukeAddComponentType) => dispatch => {
    const { components, activeComponentMeta } = store.getState().DocumentStore;
    const { dealTableId } = store.getState().QuotationStore;
    let isDealtableComponent = false;
    let isGoogleSheetComponent = false;
    const component = components[sectionID] && components[sectionID].content;
    if (
      component.type === DOCUMENT_COMPONENT_TYPES.DEAL_TABLE ||
      component.type === DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE
    ) {
      isDealtableComponent = true;
    } else if (component.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET) {
      isGoogleSheetComponent = true;
    }
    if (isDealtableComponent && dealTableId)
      store.dispatch(removeQuotetableData());
    if (isGoogleSheetComponent)
      store.dispatch(removeGoogleSheetData(sectionID));
    dispatch({
      type: "REMOVE_COMPONENT_IN_DOCUMENT",
      payload: sectionID,
    });
    // this dispatch is being called here in header/footer first time created case
    if (nukeAddComponentType) {
      if (activeComponentMeta.componentId) {
        dispatch({
          type: "UPDATE_COMPONENT_META_IN_TOOLBAR",
          payload: {},
        });
      }
      dispatch({
        type: "UPDATE_ADD_COMPONENT_TYPE",
        payload: null,
      });
    }
  };

export const updateOutlineLabel =
  (newSection, mode, oldSection) => dispatch => {
    dispatch({
      type: "UPDATE_OUTLINE_LABEL",
      payload: { component: newSection },
    });
    updateSection(mode)(newSection)
      .then(() => {})
      // to handle fallback case
      .catch(error => {
        console.error("Error", error);
        dispatch({
          type: "UPDATE_OUTLINE_LABEL",
          payload: { component: oldSection },
        });
      });
  };

export const reOrderDocumentSectionList = sectionList => dispatch => {
  dispatch({
    type: "REORDER_DOCUMENT_SECTIONLIST",
    payload: {
      sectionList,
    },
  });
};

export const deleteDocSignerSection =
  (mode, signerData, docId, updatedSignerData) => dispatch =>
    new Promise((resolve, reject) => {
      deleteSigner(mode)(signerData, docId)
        .then(() => {
          const state = store.getState().DocumentStore;
          const {
            document: { signatories },
          } = state;
          const updatedSignatories = JSON.parse(JSON.stringify(signatories));
          const { component_id: compId } = signerData[0];
          updatedSignatories.forEach(signer => {
            if (signer.component_id === compId) {
              signer.signers = updatedSignerData;
            }
          });

          dispatch({
            type: "UPDATE_DOC_SIGNATORIES",
            payload: { updatedSignatories },
          });
          resolve("success");
        })
        .catch(error => {
          console.error("docActions =>", error);
          reject(error);
        });
    });

export const updateDataForSignatureSection =
  (mode, signerData, docId) => dispatch =>
    new Promise((resolve, reject) => {
      updateSignatories(mode)(signerData, docId)
        .then(res => {
          const state = store.getState().DocumentStore;
          const {
            document: { signatories },
          } = state;
          const updatedSignatories = JSON.parse(JSON.stringify(signatories));
          updatedSignatories.forEach(signer => {
            if (signer.component_id === res[0].component_id) {
              let found = false;
              signer.signers.forEach((d, index) => {
                if (d.id === res[0].signers[0].id) {
                  signer.signers[index] = { ...res[0].signers[0] };
                  found = true;
                }
              });
              if (!found) {
                signer.signers.push(res[0].signers[0]);
              }
            }
          });
          dispatch({
            type: "UPDATE_DOC_SIGNATORIES",
            payload: { updatedSignatories },
          });
          resolve("success");
        })
        .catch(error => {
          console.error("docActions =>", error);
          reject(error);
        });
    });

export const updateDataForStripePaymentSection = component => dispatch =>
  new Promise((resolve, reject) => {
    updateDocumentComponentService(component)
      .then(() => {
        dispatch({
          type: "UPDATE_DOCUMENT_COMPONENT",
          payload: { component },
        });
        resolve("success");
      })
      .catch(error => {
        console.error("docActions =>", error);
        reject(error);
      });
  });

export const updateDataForTemplateSignatureSection = component => dispatch =>
  new Promise((resolve, reject) => {
    updateTemplateComponentService(component)
      .then(() => {
        dispatch({
          type: "UPDATE_DOCUMENT_COMPONENT",
          payload: { component },
        });
        resolve("success");
      })
      .catch(error => {
        console.error("docActions =>", error);
        reject(error);
      });
  });

export const updateDataForTemplateStripePaymentSection =
  component => dispatch =>
    new Promise((resolve, reject) => {
      updateTemplateComponentService(component)
        .then(() => {
          dispatch({
            type: "UPDATE_DOCUMENT_COMPONENT",
            payload: { component },
          });
          resolve("success");
        })
        .catch(error => {
          console.error("docActions =>", error);
          reject(error);
        });
    });

export const updateDocumentSectionAction = component => dispatch =>
  new Promise((resolve, reject) => {
    updateDocumentComponentService(component)
      .then(() => {
        dispatch({
          type: "UPDATE_DOCUMENT_COMPONENT",
          payload: { component },
        });
        resolve("success");
      })
      .catch(error => {
        console.error("docActions =>", error);
        reject(error);
      });
  });

export const acceptRejectSectionChanges =
  (sectionID, entityID, accept, mode = "DOCUMENT") =>
  () => {
    const state = store.getState().DocumentStore;
    const { components } = state;
    const section =
      components && components[sectionID]
        ? components[sectionID].content
        : null;
    if (section) {
      const updatedSection = removeEntityFromSection(
        section,
        entityID,
        accept,
        mode,
      );
      store.dispatch(updateDocumentSectionAction(updatedSection));
    }
  };

// This is to update all fields used for fields in clause
const allUpdateUsedFormFields = updatedList => dispatch =>
  dispatch({
    type: "ALL_UPDATE_USED_FORM_FIELD",
    payload: updatedList,
  });

export const updateDynamicFieldsInDocForCatalog =
  (id, newFieldUsed, preventFormFieldUpdateInSection) => dispatch =>
    new Promise(resolve => {
      if (id) {
        const reduxState = store.getState();
        const {
          components,
          document: {
            fields_used: fieldUsed,
            template_id: templateID,
            id: docId,
          },
        } = reduxState.DocumentStore;
        const { dealTableId } = reduxState.QuotationStore;
        const { priceBook: { [dealTableId]: priceBook = {} } = {} } =
          reduxState.DealTableStore;
        const documentType = templateID
          ? DOCUMENT_MODE.TEMPLATE_DOCUMENT
          : DOCUMENT_MODE.DOCUMENT;
        const currency = priceBook ? priceBook.currency : DEFAULT_CURRENCY;
        updateDocumentFieldCatalog(docId, newFieldUsed).then(response => {
          const { updatedFields, completeField } =
            getUpdatedFormFieldsWithFieldCatalog(fieldUsed, response.Fields);
          if (!preventFormFieldUpdateInSection) {
            const updatedSectionList =
              getUpdatedDynamicFieldsInSectionsForCatalog(
                components,
                documentType,
                currency,
                updatedFields,
                completeField,
              );
            dispatch(batchUpdateSectionInDocument(updatedSectionList.sections));
          }
          dispatch(updateUsedFormFields(completeField));
          resolve();
        });
      }
    });

// eslint-disable-next-line no-unused-vars
export const updateDynamicFieldsInDoc =
  (
    id,
    value,
    isShared,
    sharingHash,
    fillerType,
    preventFormFieldUpdateInSection,
  ) =>
  dispatch =>
    new Promise(resolve => {
      if (id) {
        const reduxState = store.getState();
        const {
          components,
          document: {
            fields_used: fieldUsed,
            all_fields_used: allFieldsUsed,
            template_id: templateID,
            id: docId,
          },
        } = reduxState.DocumentStore;
        const { dealTableId } = reduxState.QuotationStore;
        const { priceBook: { [dealTableId]: priceBook = {} } = {} } =
          reduxState.DealTableStore;
        const documentType = templateID
          ? DOCUMENT_MODE.TEMPLATE_DOCUMENT
          : DOCUMENT_MODE.DOCUMENT;
        const currency = priceBook ? priceBook.currency : DEFAULT_CURRENCY;

        const formField = fieldUsed.find(field => field.id === id);
        let rawValue = value;
        if (formField && formField.type === "TABLE") {
          rawValue = getTableDBContent(value, DOCUMENT_MODE.DOCUMENT);
        }

        if (isShared) {
          updateDocumentFieldNonLoggedIn(docId, sharingHash, [
            { id, value: rawValue, filler_type: fillerType },
          ]).then(response => {
            const {
              updatedFields,
              updatedField,
              allUpdatedField,
              allUpdatedFields,
            } = getUpdatedFormFieldsWithField(
              fieldUsed,
              response.Fields,
              true,
              allFieldsUsed,
            );
            if (!preventFormFieldUpdateInSection) {
              const updatedSectionList = getUpdatedDynamicFieldsInSections(
                components,
                documentType,
                currency,
                updatedFields,
                updatedField,
                allUpdatedFields,
                allUpdatedField,
              );
              dispatch(
                batchUpdateSectionInDocument(updatedSectionList.sections),
              );
            }
            dispatch(updateUsedFormFields(updatedFields));
            // For updating fields in clause
            dispatch(allUpdateUsedFormFields(allUpdatedFields));
            resolve();
          });
        } else {
          if (formField && formField.type === "TABLE") {
            fillerType = "SENDER";
          }
          updateDocumentField(docId, [
            { id, value: rawValue, filler_type: fillerType },
          ]).then(response => {
            if (formField && formField.type === "TABLE") {
              response.Fields[0].value = value;
            }
            const {
              updatedFields,
              updatedField,
              allUpdatedField,
              allUpdatedFields,
            } = getUpdatedFormFieldsWithField(
              fieldUsed,
              response.Fields,
              true,
              allFieldsUsed,
            );
            if (!preventFormFieldUpdateInSection) {
              const updatedSectionList = getUpdatedDynamicFieldsInSections(
                components,
                documentType,
                currency,
                updatedFields,
                updatedField,
                allUpdatedFields,
                allUpdatedField,
              );
              dispatch(
                batchUpdateSectionInDocument(updatedSectionList.sections),
              );
            }
            dispatch(updateUsedFormFields(updatedFields));
            // For updating fields in clause
            dispatch(allUpdateUsedFormFields(allUpdatedFields));
            resolve();
          });
        }
      }
    });

export const updateDynamicFieldsInMasterDoc =
  (id, value, preventFormFieldUpdateInSection) => dispatch =>
    new Promise(resolve => {
      if (id) {
        const reduxState = store.getState();
        const {
          components,
          document: {
            fields_used: fieldUsed,
            all_fields_used: allFieldsUsed,
            template_id: templateID,
          },
        } = reduxState.DocumentStore;
        const { dealTableId } = reduxState.QuotationStore;
        const { priceBook: { [dealTableId]: priceBook = {} } = {} } =
          reduxState.DealTableStore;

        const documentType = templateID
          ? DOCUMENT_MODE.TEMPLATE_DOCUMENT
          : DOCUMENT_MODE.DOCUMENT;
        const currency = priceBook ? priceBook.currency : DEFAULT_CURRENCY;
        const {
          updatedFields,
          updatedField,
          allUpdatedField,
          allUpdatedFields,
        } = changeFormFieldsValue(id, value, fieldUsed, allFieldsUsed);

        if (!preventFormFieldUpdateInSection) {
          const updatedSectionList = getUpdatedDynamicFieldsInSections(
            components,
            documentType,
            currency,
            updatedFields,
            updatedField,
            allUpdatedField,
            allUpdatedFields,
          );
          dispatch(batchUpdateSectionInDocument(updatedSectionList.sections));
        }

        dispatch({
          type: "FORM_UPDATE_MASTER_DOCUMENT",
          payload: updatedFields,
        });
        dispatch({
          type: "FORM_ALL_UPDATE_MASTER_DOCUMENT",
          payload: allUpdatedFields,
        });
        resolve();
      }
    });

export const updateDynamicFieldsRecipientTpyeInMasterDoc =
  (id, data, newData) => dispatch => {
    if (id) {
      updateDocumentRecipientField(id, newData).then(() => {
        dispatch({
          type: "FORM_UPDATE_MASTER_DOCUMENT",
          payload: data,
        });
      });
    }
  };

export const updateDynamicFieldsRecipientTypeinDoc =
  (id, fillerType, preventFormFieldUpdateInSection) => dispatch =>
    new Promise((resolve, reject) => {
      const reduxState = store.getState();
      const {
        components,
        document: {
          fields_used: fieldUsed,
          all_fields_used: allFieldsUsed,
          template_id: templateID,
          id: docId,
        },
      } = reduxState.DocumentStore;
      const { dealTableId } = reduxState.QuotationStore;
      const { priceBook: { [dealTableId]: priceBook = {} } = {} } =
        reduxState.DealTableStore;
      const documentType = templateID
        ? DOCUMENT_MODE.TEMPLATE_DOCUMENT
        : DOCUMENT_MODE.DOCUMENT;
      const currency = priceBook ? priceBook.currency : DEFAULT_CURRENCY;
      dispatch(updateDocSaveIndicator("SAVING"));
      updateDocumentFillerType(docId, {
        id,
        filler_type: fillerType,
      })
        .then(response => {
          const {
            updatedFields,
            updatedField,
            allUpdatedField,
            allUpdatedFields,
          } = getUpdatedFormFieldsWithField(
            fieldUsed,
            response.Fields,
            false,
            allFieldsUsed,
          );
          if (!preventFormFieldUpdateInSection) {
            const updatedSectionList = getUpdatedDynamicFieldsInSections(
              components,
              documentType,
              currency,
              updatedFields,
              updatedField,
              allUpdatedField,
              allUpdatedFields,
            );
            dispatch(batchUpdateSectionInDocument(updatedSectionList.sections));
          }
          dispatch(updateUsedFormFields(updatedFields));
          // For updating fields in clause
          dispatch(allUpdateUsedFormFields(allUpdatedFields));
          dispatch(updateDocSaveIndicator("SAVED"));
          resolve(response.Fields);
        })
        .catch(err => {
          dispatch(updateDocSaveIndicator("SAVE_FAILED"));
          reject(err);
        });
    });

export const prepareDocForm = data => dispatch => {
  dispatch({
    type: "DOC_FORM",
    payload: data,
  });
};

export const changeDocFormValidFlag = () => dispatch => {
  const reduxState = store.getState();
  const { docForm, components } = reduxState.DocumentStore;
  const flag = components ? validateDocForm(docForm, components) : false;
  dispatch({
    type: "IS_DOC_FORM_VALID",
    payload: flag,
  });
};

export const updateFormRowDataField =
  (id, value, compositeFieldKeyName) => () => {
    if (id) {
      const reduxState = store.getState();
      const { docForm } = reduxState.DocumentStore;
      const data = [...docForm];
      const fieldIndex = data.findIndex(item => item.id === id);
      const tempFieldObj = { ...data[fieldIndex] };
      if (compositeFieldKeyName) {
        const tempValue = {
          ...tempFieldObj.value,
          [compositeFieldKeyName]: value,
        };
        tempFieldObj.value = tempValue;
      } else {
        tempFieldObj.value = value;
      }
      data[fieldIndex] = tempFieldObj;
      store.dispatch(prepareDocForm(data));
      store.dispatch(changeDocFormValidFlag());
    }
  };

export const fetchDynamicFields = () => dispatch =>
  new Promise((resolve, reject) => {
    fetchDynamicFieldsService()
      .then(response => {
        dispatch({
          type: "ALL_DYNAMIC_FIELDS",
          payload: response.fields,
        });
        resolve("success");
      })
      .catch(error => {
        console.error("docActions =>", error);
        reject(error);
      });
  });

export const editApprovedDocument = docID => () =>
  new Promise((resolve, reject) => {
    const state = store.getState().DocumentStore;
    const {
      content: { sections },
    } = state;
    const sectionsWithNoEmptyContainer = sections.filter(
      section => section.type !== "EmptyContainer",
    );
    const sectionList = createDocumentRevision(sectionsWithNoEmptyContainer);
    editApprovedDocumentService(docID, sectionList)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateClauseOptionsinDoc = (id, value) => dispatch => {
  const state = store.getState().DocumentStore;
  const { components, docForm } = state;
  const sec = Object.entries(components).find(
    section =>
      section[1].content.clauseOptions &&
      section[1].content.clauseOptions.id === id,
  );
  const clauseSection = sec && sec[1] && sec[1].content;
  if (clauseSection) {
    clauseSection.clauseOptions.value = value;
    updateDocumentComponentService(clauseSection)
      .then(() => {
        dispatch({
          type: "UPDATE_CLAUSE_OPTIONS_SECTION_IN_DOCUMENT",
          payload: {
            section: clauseSection,
            value,
            isDocFormValid: validateDocForm(docForm, {
              ...components,
              [clauseSection.id]: {
                ...components[clauseSection.id],
                content: clauseSection,
              },
            }),
          },
        });
      })
      .catch(error => {
        console.error("docActions =>", error);
      });
  }
};

export const sendForSignature = (esignId, esignType) => dispatch =>
  new Promise((resolve, reject) => {
    const signaturePayload = {
      esignId,
      esignType,
    };
    // const docStatusConfigs = generateDocStatusConfigs("SENT", "SENT");
    sendDocumentForSignature(signaturePayload)
      .then(response => {
        dispatch({
          type: "TOGGLE_IFRAME_VIEW",
          payload: {
            iframeUrl: "",
            envelopeID: "",
            // docStatusConfigs,
            status: "SENT",
            stage: "SENT",
            isSentForSignature: false,
          },
        });
        resolve(response);
      })
      .catch(error => {
        console.error("docActions =>", error);
        reject(error);
      });
  });

export const cancleESignature = docId => dispatch =>
  new Promise((resolve, reject) => {
    cancleESignatureService(docId)
      .then(response => {
        dispatch({
          type: "CANCLE_ESIGNATURE",
          payload: {
            stage: "DRAFT",
          },
        });
        resolve(response);
      })
      .catch(error => {
        console.error("DocumentActions => cancleESignature => Error ", error);
        reject(error);
      });
  });

export const docAcceptAndSignAction = (docId, sharinghash) => () =>
  new Promise((resolve, reject) => {
    docAccepAndSignService(docId, sharinghash)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          "DocumentActions => docAcceptAndSignAction => Error ",
          error,
        );
        reject(error);
      });
  });

export const docAfterAccepAndSignAction = (docId, sharinghash) => () =>
  new Promise((resolve, reject) => {
    docAfterAccepAndSignService(docId, sharinghash)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          "DocumentActions => docAfterAccepAndSignAction => Error ",
          error,
        );
        reject(error);
      });
  });

export const removeHighlightSelectionInDocument = sectionID => dispatch => {
  dispatch({
    type: "REMOVE_HIGHLIGHT_IN_DOCUMENT",
    payload: sectionID,
  });
};

export const updateSelectedDocCategory = docCategory => dispatch => {
  dispatch({
    type: "SELECTED_DOC_CATEGORY",
    payload: docCategory,
  });
};

export const updateDocDetails = payload => dispatch =>
  new Promise((resolve, reject) => {
    updateDocDetailsService(payload)
      .then(response => {
        dispatch({
          type: "PATCH_DOCUMENT_DETAILS",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        console.debug("docActions =>", error);
        reject(error);
      });
  });

export const updateDocMetaAction = payload => dispatch => {
  dispatch({
    type: "UPDATE_DOCUMENT_META",
    payload,
  });
};

export const updateDocMeta = (payload, updateMetaInReduxOnly) => dispatch => {
  if (updateMetaInReduxOnly) {
    dispatch({
      type: "UPDATE_DOCUMENT_META",
      payload,
    });
  } else {
    return new Promise((resolve, reject) => {
      updateDocDetailsService(payload)
        .then(response => {
          dispatch({
            type: "UPDATE_DOCUMENT_META",
            payload: response,
          });
          resolve(response);
        })
        .catch(error => {
          console.debug("docActions => updateDocMeta", error);
          reject(error);
        });
    });
  }
  return false;
};

export const updatePDFFormField = (mode, docId, payload) => dispatch =>
  new Promise((resolve, reject) => {
    updatePDFFormFieldService(mode)(docId, payload)
      .then(response => {
        dispatch({
          type: "UPDATE_PDF_FORM_FIELDS",
          payload: response.fields.pdf_form_fields,
        });
        resolve(response);
      })
      .catch(error => {
        console.debug("docActions => updatePDFFormField", error);
        reject(error);
      });
  });

export const showIframeDocSign = (iframeUrl, envelopeID) => dispatch => {
  const docStatusConfigs = generateDocStatusConfigs(
    "PREPARE_FOR_SIGNATURE",
    "Customer Review",
  );
  dispatch({
    type: "TOGGLE_IFRAME_VIEW",
    payload: {
      iframeUrl,
      envelopeID,
      docStatusConfigs,
      status: "PREPARE_FOR_SIGNATURE",
      stage: "Customer Review",
      isSentForSignature: true,
    },
  });
};

export const pricebookChangeUpdateDynamicFieldsInDoc = currency => () => {
  const reduxState = store.getState();
  const { components: docComponents, docForm: fieldUsed } =
    reduxState.DocumentStore;
  const updatedSections = [];

  // Get all the form fields of type "AMOUNT"
  const amountFormFields = fieldUsed.filter(
    formField => formField.type === "AMOUNT",
  );

  // Update the "textValue" of "form_field" of those sections
  // which "form_field" is type of "AMOUNT"
  if (amountFormFields.length > 0) {
    amountFormFields.forEach(amountFormField => {
      Object.keys(docComponents).forEach(componentId => {
        const section = docComponents[componentId].content;
        let updateThisSectionFlag = false;
        if (
          Object.prototype.hasOwnProperty.call(section, "form_field") &&
          section.form_field
        ) {
          section.form_field.forEach((sectionFormField, index) => {
            if (sectionFormField.dynamicFieldId === amountFormField.id) {
              const { value } = amountFormField;
              const newField = {
                ...sectionFormField,
                value,
              };
              updateThisSectionFlag = true;
              let combinedValue = "";
              if (value !== "") {
                combinedValue = numberForamting(
                  value,
                  CURRENCY_SYMBOL[currency],
                );
              }
              newField.textValue = combinedValue;
              section.form_field[index] = newField;
            }
          });
        }
        if (updateThisSectionFlag) {
          updatedSections.push(section);
        }
      });
    });
  }

  if (updatedSections.length > 0) {
    const fields = amountFormFields.map(amountFormField => ({
      id: amountFormField.id,
      value: amountFormField.value,
    }));
    const documentType = DOCUMENT_MODE.DOCUMENT;

    // make the secton in a correct format to upddate the currency field in "html"
    const updatedComponents = updatedSections.map(section => {
      const newComponent = getContentForComponent(section, documentType);
      const sectionID = section.id || section.section_id;
      newComponent.section_id = sectionID;
      newComponent.section_type = section.type || section.section.section_type;
      newComponent.section_name = section.header || section.section_name;
      newComponent.source = "DRAFT-JS";
      const updateComponentDetails = {
        content: newComponent,
        component_id: sectionID,
      };
      return updateComponentDetails;
    });

    // Updating the sections with current currency
    const filledSection = fillFormField(
      updatedComponents,
      documentType,
      fieldUsed,
      currency,
    );
    const updatedSectionList = convertDocumentContent(
      filledSection,
      documentType,
      fieldUsed,
    );

    batchUpdateDocumentSection(updatedSectionList.sections, fields).then(
      response => {
        // Pick necessary keys from API
        const { components } = response.Components;
        const newFilledSection = [
          ...fillFormField(components, documentType, fieldUsed, currency),
        ];
        const newUpdatedSectionList = convertDocumentContent(
          newFilledSection,
          documentType,
          fieldUsed,
        );
        store.dispatch(
          batchUpdateSectionInDocument(newUpdatedSectionList.sections),
        );
      },
    );
  }
};

export const updateDraggedSection =
  (draggedSection, draggedFrom, draggedRowIndex, draggedColumnIndex) =>
  dispatch => {
    dispatch({
      type: "UPDATE_DRAGGED_SECTION",
      payload: {
        draggedSection,
        draggedFrom,
        draggedRowIndex,
        draggedColumnIndex,
      },
    });
  };

export const toggleDocumentDiffView = () => dispatch => {
  dispatch({
    type: "TOGGLE_DOCUMENT_DIFF_VIEW",
  });
};

// new document status and asset page
export const updateDocumentStatusAction = (docId, newStatus) => dispatch =>
  new Promise((resolve, reject) => {
    updateDocumentStatusService(docId, newStatus.id)
      .then(res => {
        batch(() => {
          dispatch({
            type: "UPDATE_DOCUMENT_STATUS",
            payload: newStatus,
          });
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateDocumentClickedComponentID = (id, flag, type) => dispatch =>
  dispatch({
    type: "UPDATE_DOCUMENT_CLICKED_COMPONENT_ID",
    payload: {
      clickedActiveComponentId: id,
      preventClickedComponentIdUpdate: flag,
      clickedActiveComponentType: type,
    },
  });

export const deactivateComponentIfActive = id => dispatch =>
  dispatch({
    type: "DEACTIVATE_COMPONENT_IF_ACTIVE",
    payload: {
      clickedActiveComponentId: id,
    },
  });

export const preventEditorToDeactivate = flag => dispatch =>
  dispatch({
    type: "PREVENT_EDITOR_TO_DEACTIVATE",
    payload: flag,
  });

export const handleCustomColorDropDownOpen =
  (status, preventClickedComponentIdUpdate) => dispatch =>
    dispatch({
      type: "HANDLE_CUSTOM_COLOR_DROPDOWN_OPEN",
      payload: { status, preventClickedComponentIdUpdate },
    });

export const preventComponentToDeactivate = flag => dispatch =>
  dispatch({
    type: "PREVENT_COMPONENT_TO_DEACTIVATE",
    payload: flag,
  });

export const makeActiveEditor = (sectionID, flag) => dispatch =>
  dispatch({
    type: "MAKE_ACTIVE_EDITOR",
    payload: {
      sectionID,
      flag,
    },
  });

export const toggleCoverpageView = view => dispatch =>
  dispatch({ type: "TOGGLE_COVERPAGE_VIEW", payload: view });

export const deleteReviewersAction = (docID, reviewerID) => dispatch =>
  new Promise((resolve, reject) => {
    deleteReviewersServices(docID, reviewerID)
      .then(response => {
        dispatch({
          type: "REMOVE_REVIEWER",
          payload: {
            reviewerID,
          },
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const editReviewerPermissionAction =
  (docID, reviewerID, data) => dispatch =>
    new Promise((resolve, reject) => {
      editReviewerPermissionServices(docID, reviewerID, data)
        .then(response => {
          dispatch({
            type: "UPDATE_EDIT_PERMISSION_FOR_REVIEWER",
            payload: {
              reviewerID,
              data,
            },
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });

// ADD DOCUMENT ACTIVITIES
export const addActivities =
  (objectId, before = null, after = null, limit = null, update = false) =>
  dispatch =>
    new Promise((resolve, reject) =>
      getDocActivities(objectId, before, after, limit)
        .then(res => {
          let hasMore = false;
          if (
            res.headers &&
            res.headers.has_more &&
            res.headers.has_more === "true"
          ) {
            hasMore = true;
          }
          if (update) {
            dispatch({
              type: "UPDATE_DOCUMENT_ACTIVITIES",
              payload: {
                activities: res.data,
                hasMore,
              },
            });
          } else {
            dispatch({
              type: "ADD_DOCUMENT_ACTIVITIES",
              payload: {
                activities: res.data,
                hasMore,
              },
            });
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        }),
    );

export const removeDocumentActivities = () => dispatch =>
  dispatch({
    type: "REMOVE_DOCUMENT_ACTIVITIES",
  });

export const acceptanceApprovalStatusCheck =
  (docID, sharingHash, status, reviewerEmailMessage, attachmentId) =>
  dispatch => {
    window.revv_showFillAndAcceptPopUp = true;
    return new Promise((resolve, reject) =>
      acceptanceApprovalStatusCheckService(
        docID,
        sharingHash,
        status,
        reviewerEmailMessage,
        attachmentId,
      )
        .then(res => {
          dispatch({
            type: "UPDATE_ACCEPTANCE_STATUS",
            payload: res,
          });
          resolve("success");
        })
        .catch(err => {
          reject(err);
        }),
    );
  };

// UNDO/REDO STACK ACTIONS
export const reactionsOnUndoClick = () => dispatch => {
  const {
    DocumentStore,
    TemplateStore,
    EditorStore: {
      activeEditorState,
      activeComponent,
      activeComponentInfo,
      lastEditorChangeTime,
      forceUpdateEditorConfigs,
    },
  } = store.getState();
  const { isOpen, clause } = TemplateStore.clauseOptions;
  // If the create clause option pane is open then,
  // don't allow undo/redo
  if (!isOpen && !clause) {
    const {
      stack: { undo, redo },
      activeComponentMeta,
      preventClickedComponentIdUpdate,
    } = DocumentStore;

    if (undo.length > 0) {
      const command = undo.shift();
      if (!command.unDoable) {
        // ignore if popped item is not a command
        return;
      }

      if (
        activeEditorState ||
        activeComponent ||
        activeComponentInfo ||
        lastEditorChangeTime ||
        forceUpdateEditorConfigs
      ) {
        dispatch({ type: "NUKE_ACTIVE_EDITOR" });
      }

      if (!command.preventNukeActiveState) {
        if (Object.keys(activeComponentMeta).length > 0) {
          dispatch({
            type: "UPDATE_COMPONENT_META_IN_TOOLBAR",
            payload: {},
          });
        }

        if (!preventClickedComponentIdUpdate) {
          dispatch({
            type: "UPDATE_DOCUMENT_CLICKED_COMPONENT_ID",
            payload: {
              clickedActiveComponentId: null,
              preventClickedComponentIdUpdate: true,
              clickedActiveComponentType: null,
            },
          });
        }
      }

      command.undo();

      let redoStack = [redo];
      if (command.redoable) {
        redoStack =
          redo.length >= UNDO_REDO_STACK_LIMIT
            ? [command].concat(redo.slice(0, -1))
            : [command].concat(redo);
      }
      dispatch({
        type: "REACTION_ON_DOCUMENT_UNDO_ACTION",
        payload: {
          redoStack,
          undoStack: undo,
        },
      });
    } else {
      console.error("No more items to undo");
    }
  }
};

export const reactionsOnRedoClick = () => dispatch => {
  const {
    DocumentStore,
    TemplateStore,
    EditorStore: {
      activeEditorState,
      activeComponent,
      activeComponentInfo,
      lastEditorChangeTime,
      forceUpdateEditorConfigs,
    },
  } = store.getState();
  const { isOpen, clause } = TemplateStore.clauseOptions;
  // If the create clause option pane is open then,
  // don't allow undo/redo
  if (!isOpen && !clause) {
    const {
      stack: { undo, redo },
      activeComponentMeta,
    } = DocumentStore;

    if (redo.length > 0) {
      const command = redo.shift();
      if (!command.unDoable || !command.redoable) {
        // ignore if popped item is not a command
        return;
      }

      if (!command.preventNukeActiveState) {
        if (
          activeComponentMeta &&
          Object.keys(activeComponentMeta).length > 0
        ) {
          dispatch({
            type: "UPDATE_COMPONENT_META_IN_TOOLBAR",
            payload: {},
          });
        }
      }
      if (
        activeEditorState ||
        activeComponent ||
        activeComponentInfo ||
        lastEditorChangeTime ||
        forceUpdateEditorConfigs
      ) {
        dispatch({ type: "NUKE_ACTIVE_EDITOR" });
      }

      command.execute();

      const undoStack =
        undo.length >= UNDO_REDO_STACK_LIMIT
          ? [command].concat(undo.slice(0, -1))
          : [command].concat(undo);
      dispatch({
        type: "REACTION_ON_DOCUMENT_REDO_ACTION",
        payload: {
          redoStack: redo,
          undoStack,
        },
      });
    } else {
      console.error("No more items to redo");
    }
  }
};

export const undoComponentUpdate = payload => dispatch => {
  dispatch({
    type: "UNDO_COMPONENT_UPDATE",
    payload,
  });
};

export const resetUndoRedoStack = () => dispatch => {
  dispatch({
    type: "RESET_UNDO_REDO_STACK",
  });
};

export const nukeDocument = () => dispatch => {
  dispatch({
    type: "NUKE_DOCUMENT",
  });
};

export const generatePermaLinkAction = payload => dispatch =>
  new Promise((resolve, reject) =>
    generatePermaLinkService(payload)
      .then(res => {
        dispatch({
          type: "GENERATE_PERMA_LINK",
          payload: res,
        });
        resolve("success");
      })
      .catch(err => {
        reject(err);
      }),
  );

export const generateSnapLinkAction = payload => dispatch =>
  new Promise((resolve, reject) =>
    generateSnapLinkService(payload)
      .then(res => {
        dispatch({
          type: "GENERATE_SNAP_LINK",
          payload: res,
        });
        resolve("success");
      })
      .catch(err => {
        reject(err);
      }),
  );

export const getPermaLinkAction = (objectId, objectType) => dispatch =>
  new Promise((resolve, reject) =>
    getPermaLinkService(objectId, objectType)
      .then(res => {
        if (res.data !== null) {
          dispatch({
            type: "GET_PERMA_LINK",
            payload: res,
          });
        }
        resolve("success");
      })
      .catch(err => {
        reject(err);
      }),
  );

export const getSnapLinkAction = (objectId, objectType) => dispatch =>
  new Promise((resolve, reject) =>
    getSnapLinkService(objectId, objectType)
      .then(res => {
        if (res.data !== null) {
          dispatch({
            type: "GET_SNAP_LINK",
            payload: res,
          });
        }
        resolve("success");
      })
      .catch(err => {
        reject(err);
      }),
  );

export const deletePermaLinkAction = (objectId, objectType) => dispatch =>
  new Promise((resolve, reject) =>
    deletePermaLinkService(objectId, objectType)
      .then(res => {
        dispatch({
          type: "DELETE_PERMA_LINK",
          payload: res,
        });
        resolve("success");
      })
      .catch(err => {
        reject(err);
      }),
  );

export const deleteSnapLinkAction = (objectId, objectType) => dispatch =>
  new Promise((resolve, reject) =>
    deleteSnapLinkService(objectId, objectType)
      .then(res => {
        dispatch({
          type: "DELETE_SNAP_LINK",
          payload: res,
        });
        resolve("success");
      })
      .catch(err => {
        reject(err);
      }),
  );

export const coverpageThemeAction = view => dispatch => {
  const reduxState = store.getState();
  const { coverpageThemeActionLabel } = reduxState.DocumentStore;
  if (!(coverpageThemeActionLabel === null && view === null)) {
    dispatch({ type: "COVERPAGE_THEME_ACTION", payload: view });
  }
};

export const initSharedPermaSignedDocumentData = payload => dispatch => {
  dispatch({
    type: "INIT_SHARED_PERMA_DOCUMENT_DATA",
    payload,
  });
};

export const updateComponentMeta = componentMeta => dispatch => {
  dispatch({
    type: "UPDATE_COMPONENT_META_IN_TOOLBAR",
    payload: { componentMeta },
  });
};

// export const updateComponentMetaForNotes = componentMeta => dispatch => {
//   dispatch({
//     type: "UPDATE_COMPONENT_META_FOR_NOTES_IN_TOOLBAR",
//     payload: componentMeta,
//   });
// };

export const updateSubmitRejectSignerFillerAction =
  (docID, sharingHash, view, data) => dispatch =>
    new Promise((resolve, reject) => {
      const {
        document: { document_flow: docFlow },
      } = store.getState().DocumentStore;
      updateSubmitRejectSignerFiller(docID, sharingHash, view, data)
        .then(res => {
          window.revv_showFillAndAcceptPopUp = true;
          const payload = res;
          if (docFlow === "ACCEPTANCE") {
            payload.recipientType = "ACCEPTOR";
          } else {
            payload.recipientType = "SIGNER";
          }

          if (!res.doc_stage) {
            if (view === "submit") {
              payload.doc_stage = "SENT";
            } else {
              payload.doc_stage = "DECLINED";
            }
          }
          dispatch({
            type: "UPDATE_ACCEPTANCE_STATUS",
            payload,
          });
          dispatch({
            type: "UPDATE_DOCUMENT_RECIPIENT",
            payload,
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const updateDocSignatoriesAction = updatedSignatories => dispatch =>
  dispatch({
    type: "UPDATE_DOC_SIGNATORIES",
    payload: { updatedSignatories },
  });

export const updateDocStage = docStage => dispatch =>
  dispatch({
    type: "UPDATE_DOC_STAGE",
    payload: docStage,
  });

export const updateSubmitDeclineInternalAction =
  (docId, type, userId, data, docStage) => dispatch =>
    new Promise((resolve, reject) => {
      updateSubmitDeclineInternalService(docId, type, data)
        .then(res => {
          window.revv_showFillAndAcceptPopUp = true;
          const payload = res;
          payload.recipientType = "SIGNER";
          payload.user_id = userId;
          // if (!res.doc_stage) {
          //   if (type === "submit") {
          //     payload.doc_stage = "SENT";
          //   } else {
          //     payload.doc_stage = "DECLINED";
          //   }
          // }
          // dispatch({
          //   type: "UPDATE_ACCEPTANCE_STATUS",
          //   payload,
          // });
          dispatch({
            type: "UPDATE_DOCUMENT_RECIPIENT_INTERNAL",
            payload,
          });
          resolve(res);
        })
        .catch(err => {
          dispatch({
            type: "UPDATE_ACCEPTANCE_STATUS",
            payload: { doc_stage: docStage },
          });
          reject(err);
        });
    });

// SUPPORT ADDITION OF BLOCKS INTO PDF DOCUMENT
export const addEsignBlockData =
  (mode, docID, payload, componentType = "Signature") =>
  dispatch =>
    new Promise((resolve, reject) =>
      updateSignatories(mode)(payload, docID)
        .then(res => {
          const content = {
            header: "",
            id: res[0].component_id,
            label: `Signature ${res.length}`,
            lock: false,
            type: "Signature",
            data: res[0].signers,
          };
          batch(() => {
            dispatch({
              type: "REACTION_ON_ADDING_ESIGN_BLOCK",
              payload: {
                res,
                content,
              },
            });
            dispatch({
              type: "UPDATE_TOOLPANE_DATA_FOR_SIGNATURE",
              payload: {
                sectionData: content,
              },
            });
            dispatch({
              type: "UPDATE_DOCUMENT_CLICKED_COMPONENT_ID",
              payload: {
                clickedActiveComponentId: res[0].component_id,
                preventClickedComponentIdUpdate: false,
                clickedActiveComponentType: componentType,
              },
            });
          });
          resolve("success");
        })
        .catch(err => {
          reject(err);
        }),
    );

// SUPPORT REPOSITION OF BLOCKS INTO PDF DOCUMENT
export const updateAddEsignBlockData =
  (payload, componentType = "Signature") =>
  dispatch => {
    const res = payload;
    const content = {
      header: "",
      id: res[0].component_id,
      label: `Signature ${payload.length}`,
      lock: false,
      type: "Signature",
      data: res[0].signers,
    };
    batch(() => {
      dispatch({
        type: "REACTION_ON_ADDING_ESIGN_BLOCK",
        payload: {
          res,
          content,
        },
      });
      dispatch({
        type: "UPDATE_TOOLPANE_DATA_FOR_SIGNATURE",
        payload: {
          sectionData: content,
        },
      });
      dispatch({
        type: "UPDATE_DOCUMENT_CLICKED_COMPONENT_ID",
        payload: {
          clickedActiveComponentId: res[0].component_id,
          preventClickedComponentIdUpdate: false,
          clickedActiveComponentType: componentType,
        },
      });
    });
  };

export const stripeUserDetails = () => dispatch =>
  new Promise(resolve => {
    getStripeUser()
      .then(response => {
        if (response.StripeSubscriber.access_token) {
          console.debug(response);
          writeDataToLocalStorage("stripeData", response.StripeSubscriber);
          dispatch({
            type: "AUTH_STRIPE",
            payload: response.StripeSubscriber,
          });
        }
        resolve(response);
      })
      .catch(error => {
        if (error.response.status === 500) {
          dispatch({
            type: "STRIPE_AUTH_FLAG",
            payload: false,
          });
        }
      });
  });

export const getAuthStripe = config => dispatch =>
  new Promise((resolve, reject) => {
    console.debug("payload for authstrip is", config);
    authStripe(config)
      .then(response => {
        console.debug("response for authstrip is", response);
        writeDataToLocalStorage("stripeData", response.StripeSubscriber);
        dispatch({
          type: "AUTH_STRIPE",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getStripePaymentOnSave = payload => () =>
  new Promise((resolve, reject) => {
    sendStripePaymentOnSave(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug("docActions =>", error);
        reject(error);
      });
  });

export const generateStripeButtonSessionId = config => dispatch =>
  new Promise((resolve, reject) => {
    getStripePaymentSessionId(config)
      .then(response => {
        dispatch({
          type: "ADD_STRIPE_SESSION_ID",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAllPaymentDetails = (docId, stripeID) => dispatch =>
  new Promise((resolve, reject) => {
    getStripePaymentDetails(docId, stripeID)
      .then(response => {
        let isPaid = null;
        if (
          response.StripePaymentDetails &&
          response.StripePaymentDetails.length
        ) {
          isPaid = response.StripePaymentDetails.find(
            elem => elem.payment_status === "paid",
          );
        }
        if (isPaid) {
          dispatch({
            type: "STRIPE_PAYMENT_UPDATE",
            payload: "Paid",
          });
        }
        dispatch({
          type: "STRIPE_BUTTON_DETAILS",
          payload: response.StripePaymentDetails,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAllPaymentDetailsWithHash =
  (docId, userID, sharingHash) => dispatch =>
    new Promise((resolve, reject) => {
      getStripePaymentDetailsWithHash(docId, userID, sharingHash)
        .then(response => {
          let isPaid = null;
          if (
            response.StripePaymentDetails &&
            response.StripePaymentDetails.length
          ) {
            isPaid = response.StripePaymentDetails.find(
              elem => elem.payment_status === "paid",
            );
          }
          if (isPaid) {
            dispatch({
              type: "STRIPE_PAYMENT_UPDATE",
              payload: "Paid",
            });
          }
          dispatch({
            type: "STRIPE_BUTTON_DETAILS",
            payload: response.StripePaymentDetails,
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });

export const deactivateStripeUser = stripeID => dispatch =>
  new Promise((resolve, reject) => {
    deactivateStripe(stripeID)
      .then(response => {
        removeDataFromLocalStorage("stripeData");
        dispatch({
          type: "DEACTIVATE_STRIPE_USER",
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAllPaymentDetailsWithPermaHash =
  (docId, userID, sharingHash) => dispatch =>
    new Promise((resolve, reject) => {
      getStripePaymentDetailsWithHashPerma(docId, userID, sharingHash)
        .then(response => {
          let isPaid = null;
          if (
            response.StripePaymentDetails &&
            response.StripePaymentDetails.length
          ) {
            isPaid = response.StripePaymentDetails.find(
              elem => elem.payment_status === "paid",
            );
          }
          if (isPaid) {
            dispatch({
              type: "STRIPE_PAYMENT_UPDATE",
              payload: "Paid",
            });
          }
          dispatch({
            type: "STRIPE_BUTTON_DETAILS",
            payload: response.StripePaymentDetails,
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });

export const forceUpdateEditorSectionIdAction = sectionId => dispatch => {
  dispatch({
    type: "FORCE_UPDATE_EDITOR_SECTION_ID",
    payload: sectionId,
  });
};

export const removeDisabledStripeButtonfromDoc =
  (stripeData, docId) => dispatch =>
    new Promise((resolve, reject) => {
      deleteStripeFromDocument(stripeData, docId)
        .then(response => {
          stripeData.component_id.forEach(id => {
            dispatch({
              type: "DELETE_DOCUMENT_COMPONENT",
              payload: id,
            });
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });

export const executeCommand = command => dispatch => {
  command.execute();
  if (command.unDoable) {
    dispatch({
      type: "ADD_TO_UNDO_STACK",
      payload: command,
    });
  }
};

// updates layout inside coverpage, header-footer, etc
export const updateLayoutInsideComponent =
  (componentID, layout, draggedTo) => dispatch => {
    dispatch({
      type: "UPDATE_LAYOUT_INSIDE_COMPONENT",
      payload: {
        componentID,
        layout,
        draggedTo,
      },
    });
  };

export const updateSharedUsers = payload => dispatch => {
  const { sharedUsersSender } = payload;

  dispatch({
    type: "UPDATE_SHARED_USERS",
    payload: {
      sharedUsersSender,
    },
  });
};

export const updateEmailMessage = payload => dispatch => {
  const emailMessage = payload;
  dispatch({
    type: "UPDATE_EMAIL_MESSAGE",
    payload: {
      emailMessage,
    },
  });
};

export const updateVideoUrl = payload => dispatch => {
  const videoKycUrl = payload;
  dispatch({
    type: "UPDATE_VIDEO_URL",
    payload: {
      videoKycUrl,
    },
  });
};

export const updateEmailResendAction = (docID, payload) => dispatch =>
  new Promise((resolve, reject) => {
    updateEmailResendService(docID, payload)
      .then(response => {
        dispatch({
          type: "RESEND_EMAIL_REIPIENT",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getMasterDocData = objectId => dispatch =>
  new Promise((resolve, reject) =>
    getMasterDocDataService(objectId)
      .then(res => {
        if (res.data) {
          dispatch({
            type: "GET_MASTER_DOC",
            payload: res.data,
          });
        }
        resolve(res);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const generateMasterDocument = payload => dispatch =>
  new Promise((resolve, reject) =>
    generateMasterDocumentService(payload)
      .then(res => {
        dispatch({
          type: "GENERATE_MASTER_DOC",
          payload: res.data,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const disableMasterDocument = objectId => dispatch =>
  new Promise((resolve, reject) =>
    disableMasterDocumentService(objectId)
      .then(res => {
        dispatch({
          type: "DISABLE_MASTER_DOC",
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const updateFieldSectionMapping = newMapping => dispatch => {
  dispatch({
    type: "UPDATE_FIELDS_SECTION_MAPPING",
    payload: newMapping,
  });
};

export const createBulkDocumentAction =
  (templateId, data, payload) => dispatch =>
    new Promise((resolve, reject) =>
      createBulkDocumentService(templateId, data, payload)
        .then(res => {
          dispatch({
            type: "CREATE_BULK_DOCUMENT",
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        }),
    );

export const updateActiveComponentMeta = payload => dispatch => {
  dispatch({
    type: "UPDATE_ACTIVE_COMPONENT_META",
    payload,
  });
};

export const updateComponentEditorState = payload => dispatch => {
  dispatch({
    type: "UPDATE_COMPONENT_EDITOR_STATE",
    payload,
  });
};

// export const forceUpdateComponentEditorState = payload => dispatch => {
//   dispatch({
//     type: "FORCE_UPDATE_COMPONENT_EDITOR_STATE",
//     payload,
//   });
// };

export const initEditorWithActiveState = componentId => dispatch => {
  dispatch({
    type: "FORCE_INIT_EDITOR_STATE",
    payload: {
      clickedActiveComponentId: componentId,
      preventClickedComponentIdUpdate: true,
      clickedActiveComponentType: "HTML",
      forceInitEditorState: componentId,
    },
  });
};

export const updateEditorStateInSectionForClauseOptions =
  (clauseOptionDetails, componentId) => dispatch => {
    dispatch({
      type: "FORCE_RERENDER_WHEN_CLAUSE_OPTIONS_UPDATE",
      payload: {
        sectionId: componentId,
        clauseOptionsDetails: clauseOptionDetails.clauseOptionsDetails,
      },
    });

    dispatch({
      type: "FORCE_UPDATE_LOCAL_EDITOR_STATE",
      payload: {
        componentId,
        editorState: null,
      },
    });
  };

// export const updateEditorStateInSectionForClauseOptions =
// (clauseOptionDetails, componentId) => dispatch => {
//   const { value, clauseOptionsDetails, mode } = clauseOptionDetails;
//   const editorState = getEditorStateForClauseOptions(
//     value,
//     clauseOptionsDetails,
//     mode,
//   );
//   dispatch({
//     type: "FORCE_UPDATE_LOCAL_EDITOR_STATE",
//     payload: {
//       componentId,
//       editorState,
//     },
//   });
//   // dispatch({
//   //   type: "UPDATE_EDITOR_STATE_IN_SECTION_FOR_CLAUSE_OPTIONS",
//   //   payload: {
//   //     componentMeta: componentMetaData,
//   //     editorState,
//   //   },
//   // });
// };

// export const updateEditorStateInSectionForClauseOptions =
//   (clauseOptionDetails, componentId) => dispatch => {
//     const { value, clauseOptionsDetails, mode } = clauseOptionDetails;
//     const editorState = getEditorStateForClauseOptions(
//       value,
//       clauseOptionsDetails,
//       mode,
//     );
//     dispatch({
//       type: "FORCE_UPDATE_EDITOR_SECTION_ID",
//       payload: {
//         componentId,
//         editorState,
//       },
//     });
//     // dispatch({
//     //   type: "UPDATE_EDITOR_STATE_IN_SECTION_FOR_CLAUSE_OPTIONS",
//     //   payload: {
//     //     componentMeta: componentMetaData,
//     //     editorState,
//     //   },
//     // });
//   };

const reCalculatePageBreaksDebounced = debounce(
  dispatch =>
    dispatch({
      type: "RECALCULATE_PAGE_BREAKS",
    }),
  500,
);
// to be called from outside the pagebreak marker component
export const reCalculatePageBreaks = () => reCalculatePageBreaksDebounced;

const reCalculatePageBreaksDelayedInner = debounce(
  dispatch =>
    setTimeout(
      () =>
        dispatch({
          type: "RECALCULATE_PAGE_BREAKS",
        }),
      100,
    ),
  300,
);
// to be called from inside the pagebreak marker component
export const reCalculatePageBreaksDelayed = () =>
  reCalculatePageBreaksDelayedInner;

export const updateCurrentZoomAction = zoomConfig => dispatch => {
  const currentZoom =
    zoomConfig && zoomConfig.current ? zoomConfig.current : "100";
  dispatch({
    type: "UPDATE_CURRENT_ZOOM",
    payload: {
      currentZoom,
    },
  });
};

export const tableSelectionTypeAction = type => dispatch => {
  const reduxState = store.getState();
  const { tableSelectionType } = reduxState.DocumentStore;
  if (!(tableSelectionType === null && type === null)) {
    dispatch({
      type: "UPDATE_TABLE_SELECTION_TYPE",
      payload: type,
    });
  }
};

export const getDocumentSettingsAction = docId => dispatch =>
  new Promise((resolve, reject) =>
    getDocumentSettingsActionService(docId)
      .then(res => {
        dispatch({
          type: "GET_DOCUMENT_FORWARDING_SETTINGS",
          payload: {
            res,
          },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const updatedDocumentSettingsAction = (docId, data) => dispatch =>
  new Promise((resolve, reject) =>
    updatedDocumentSettingsActionService(docId, data)
      .then(res => {
        dispatch({
          type: "UPDATE_DOCUMENT_FORWARDING_SETTINGS",
          payload: {
            res,
          },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      }),
  );

// ------- Esign APIs -------

export const getDocSignatoriesActionV2 = docID => dispatch =>
  new Promise((resolve, reject) => {
    getDocSignatoriesV2(docID)
      .then(res => {
        dispatch({
          type: "FETCH_DOC_SIGNATORIES_V2",
          payload: {
            signatories: res,
          },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

// Add new Tag(drag drop tag) + Updates tags(signature type, block active/inactive)
// ** Update for one signer identity id at a time only
export const updateDocSignatoryActionV2 = (docID, data) => dispatch =>
  new Promise((resolve, reject) => {
    createDocSignatoryV2(docID, data)
      .then(res => {
        if (res && Array.isArray(res)) {
          const signerIdentityTags = getSignerIdentityTags(res);
          dispatch({
            type: "UPDATE_DOC_SIGNATORIES_V2",
            payload: {
              signerIdentityTags,
            },
          });
          resolve(res);
        }
      })
      .catch(err => {
        reject(err);
      });
  });

export const createDocSignerIdentityAction = docID => dispatch =>
  new Promise((resolve, reject) => {
    createDocSignerIdentity(docID)
      .then(res => {
        const signatory = new Signatory(res.id, "", "", "", []);
        dispatch({
          type: "CREATE_DOC_SIGNER_IDENTITY",
          payload: {
            signer: signatory.signer,
          },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateDocSignerIdentityAction =
  (docID, signerID, data) => dispatch =>
    new Promise((resolve, reject) => {
      updateDocSignerIdentity(docID, signerID, data)
        .then(res => {
          dispatch({
            type: "UPDATE_DOC_SIGNER_IDENTITY",
            payload: {
              signer: res,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const deleteDocSignerIdentityAction =
  (docID, signerID, data = {}) =>
  dispatch =>
    new Promise((resolve, reject) => {
      deleteDocSignerIdentity(docID, signerID, data)
        .then(res => {
          dispatch({
            type: "DELETE_DOC_SIGNER_IDENTITY",
            payload: {
              signerID,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const getDocSignerIdentitiesAction = docID => dispatch =>
  new Promise((resolve, reject) => {
    getDocSignerIdentities(docID)
      .then(res => {
        dispatch({
          type: "FETCH_DOC_SIGNER_IDENTITY",
          payload: {
            signers: res,
          },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const deleteComponentsBulkAction = (docID, componentIDS) => dispatch =>
  new Promise((resolve, reject) => {
    deleteComponentsBulk(docID, componentIDS)
      .then(() => {
        const componentIdSet = new Set();
        for (let i = 0; i < componentIDS.length; i += 1) {
          componentIdSet.add(componentIDS[i]);
        }
        dispatch({
          type: "BULK_DELETE_DOCUMENT_COMPONENTS",
          payload: { componentIdSet },
        });
      })
      .catch(err => {
        reject(err);
      });
  });

export const deleteDOCSignerTags = (docID, data) => dispatch =>
  new Promise((resolve, reject) => {
    deleteDocSigner([data], docID)
      .then(res => {
        dispatch({
          type: "DELETE_SIGNATORY_V2_TAGS",
          payload: {
            component_id: data.component_id,
            ids: data.ids,
          },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const deleteDocComponentsBulkActionV1 =
  (docID, componentIDSdata) => dispatch =>
    new Promise((resolve, reject) => {
      Promise.all(
        componentIDSdata.component_ids.map(id =>
          deleteDocumentComponentService(docID, { id }),
        ),
      )
        .then(resArr => {
          const { component_ids: componentIDS } = componentIDSdata;
          const componentIdSet = new Set();
          for (let i = 0; i < componentIDS.length; i += 1) {
            componentIdSet.add(componentIDS[i]);
          }
          dispatch({
            type: "BULK_DELETE_DOCUMENT_COMPONENTS",
            payload: { componentIdSet },
          });
          resolve(resArr);
        })
        .catch(err => {
          reject(err);
        });
    });

export const deleteDocComponentsBulkActionV1PDF =
  componentIDSdata => dispatch => {
    const { component_ids: componentIDS } = componentIDSdata;
    const componentIdSet = new Set();
    for (let i = 0; i < componentIDS.length; i += 1) {
      componentIdSet.add(componentIDS[i]);
    }
    dispatch({
      type: "BULK_DELETE_DOCUMENT_COMPONENTS",
      payload: { componentIdSet },
    });
  };

// ------ End Esign APIs --------
// ---- Template esign --------
export const getTemplateSignatoriesActionV2 = docID => dispatch =>
  new Promise((resolve, reject) => {
    getTemplateSignatoriesV2(docID)
      .then(res => {
        dispatch({
          type: "FETCH_DOC_SIGNATORIES_V2",
          payload: {
            signatories: res,
          },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

// Add new Tag(drag drop tag) + Updates tags(signature type, block active/inactive)
// ** Update for one signer identity id at a time only
export const updateTemplateSignatoryActionV2 = (docID, data) => dispatch =>
  new Promise((resolve, reject) => {
    createTemplateSignatoryV2(docID, data)
      .then(res => {
        if (res && Array.isArray(res)) {
          const signerIdentityTags = getSignerIdentityTags(res);
          dispatch({
            type: "UPDATE_DOC_SIGNATORIES_V2",
            payload: {
              signerIdentityTags,
            },
          });
          resolve(res);
        }
      })
      .catch(err => {
        reject(err);
      });
  });

export const createTemplateSignerIdentityAction = templateID => dispatch =>
  new Promise((resolve, reject) => {
    createTemplateSignerIdentity(templateID)
      .then(res => {
        const signatory = new Signatory(res.id, "", "", "", []);
        dispatch({
          type: "CREATE_DOC_SIGNER_IDENTITY",
          payload: {
            signer: signatory.signer,
          },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateTemplateSignerIdentityAction =
  (templateID, signerID, data) => dispatch =>
    new Promise((resolve, reject) => {
      updateTemplateSignerIdentity(templateID, signerID, data)
        .then(res => {
          dispatch({
            type: "UPDATE_DOC_SIGNER_IDENTITY",
            payload: {
              signer: res,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const deleteTemplateSignerIdentityAction =
  (templateID, signerID, data = {}) =>
  dispatch =>
    new Promise((resolve, reject) => {
      deleteTemplateSignerIdentity(templateID, signerID, data)
        .then(res => {
          dispatch({
            type: "DELETE_DOC_SIGNER_IDENTITY",
            payload: {
              signerID,
            },
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const getTemplateSignerIdentitiesAction = templateID => dispatch =>
  new Promise((resolve, reject) => {
    getTemplateSignerIdentities(templateID)
      .then(res => {
        dispatch({
          type: "FETCH_DOC_SIGNER_IDENTITY",
          payload: {
            signers: res,
          },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const deleteTemplateSignerTags = (templateID, data) => dispatch =>
  new Promise((resolve, reject) => {
    deleteTemplateSigner([data], templateID)
      .then(res => {
        dispatch({
          type: "DELETE_SIGNATORY_V2_TAGS",
          payload: {
            component_id: data.component_id,
            ids: data.ids,
          },
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const deleteTemplateComponentsBulkActionV1 =
  (docID, componentIDSdata) => dispatch =>
    new Promise((resolve, reject) => {
      Promise.all(
        componentIDSdata.component_ids.map(id =>
          deleteTemplateComponent(docID, { id, field_ids: { deleted: [] } }),
        ),
      )
        .then(resArr => {
          const { component_ids: componentIDS } = componentIDSdata;
          const componentIdSet = new Set();
          for (let i = 0; i < componentIDS.length; i += 1) {
            componentIdSet.add(componentIDS[i]);
          }
          dispatch({
            type: "BULK_DELETE_DOCUMENT_COMPONENTS",
            payload: { componentIdSet },
          });
          resolve(resArr);
        })
        .catch(err => {
          reject(err);
        });
    });

export const addPDFSignatureComponent =
  (componentID, componentContent) => dispatch => {
    dispatch({
      type: "ADD_PDF_SIGNATURE_COMPONENT",
      payload: {
        componentID,
        component: {
          content: componentContent,
        },
      },
    });
  };
// ------ End Template esign -----

// --------- Auto update doc title

// validation before auto updating template title
const shouldAutoUpdateDocTitle = mode => {
  const reduxState = store.getState();
  const {
    document: {
      isPdfDocument,
      name: docTitle,
      stage: docStage,
      meta_data: docMetaData,
    },
  } = reduxState.DocumentStore;
  const {
    template: {
      title: templateTitle,
      status: templateStatus,
      meta_data: tempMetaData,
    },
  } = reduxState.TemplateStore;

  // allow only in non-pdf draft mode
  if (
    isPdfDocument ||
    (mode === DOCUMENT_MODE.DOCUMENT && docStage !== "DRAFT") ||
    (mode === DOCUMENT_MODE.TEMPLATE && templateStatus !== "DRAFT")
  ) {
    return false;
  }

  const metaD = mode === DOCUMENT_MODE.TEMPLATE ? tempMetaData : docMetaData;

  // if user updated title then never update
  const userUpdatedTitle = metaD ? metaD.user_updated_title : false;
  if (userUpdatedTitle) {
    return false;
  }

  // if user not updated & all components deleted then update
  const shouldUpdateAfterDel = metaD ? metaD.should_update_title : false;
  if (shouldUpdateAfterDel) {
    return true;
  }

  // if already updated
  const alreadyUpdated = metaD ? metaD.title_updated : false;
  if (alreadyUpdated) {
    return false;
  }

  // if not updated & untitled
  if (
    (mode === DOCUMENT_MODE.TEMPLATE &&
      templateTitle === "Untitled Template") ||
    (mode === DOCUMENT_MODE.DOCUMENT && docTitle === "Untitled Document")
  ) {
    return true;
  }
  return false;
};

const autoUpdateTitleHandler = async (mode, docId, text) => {
  // update title
  const payload = {
    data: [
      {
        op: "replace",
        field: "title",
        value: {
          title: text,
        },
      },
    ],
    docId,
  };
  await new Promise((resolve, reject) =>
    updateDocMetaService(mode)(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug("docActions =>", error);
        reject(error);
      }),
  );
};

const updateAutoTitleFlagMetaValuesHandler = async (
  mode,
  docId,
  key,
  isSet,
) => {
  const state = store.getState();
  const {
    document: { meta_data: docMetaData },
  } = state.DocumentStore;
  const {
    template: { meta_data: tempMetaData },
  } = state.TemplateStore;

  const updatedMeta =
    mode === DOCUMENT_MODE.TEMPLATE ? { ...tempMetaData } : { ...docMetaData };
  updatedMeta[key] = isSet;

  const data = [
    {
      op: "replace",
      field: "meta_data",
      value: { meta_data: updatedMeta },
    },
  ];
  await new Promise((resolve, reject) =>
    updateDocMetaService(mode)({ docId, data })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug("docActions =>", error);
        reject(error);
      }),
  );

  return { meta_data: updatedMeta };
};

export const autoUpdateTitle = (mode, docId, newTitle) => async dispatch => {
  const isUpdateAllowed = await shouldAutoUpdateDocTitle(mode);
  if (!isUpdateAllowed) {
    return;
  }
  const reduxState = store.getState();
  const { components, layout } = reduxState.DocumentStore;

  // if title not passed then get text from first element
  let text = newTitle;
  if (!text) {
    text = getFirstComponentText(layout, components);
  }
  if (!text) {
    return;
  }

  await autoUpdateTitleHandler(mode, docId, text);
  if (mode === DOCUMENT_MODE.TEMPLATE) {
    dispatch({
      type: "UPDATE_TEMPLATE_TITLE",
      payload: text,
    });
  } else {
    dispatch({
      type: "PATCH_DOCUMENT_DETAILS",
      payload: { title: text },
    });
  }

  const updatedMeta = await updateAutoTitleFlagMetaValuesHandler(
    mode,
    docId,
    "title_updated",
    true,
  );
  const action =
    mode === DOCUMENT_MODE.TEMPLATE
      ? "UPDATE_TEMPLATE_META"
      : "UPDATE_DOCUMENT_META";
  dispatch({
    type: action,
    payload: updatedMeta,
  });

  const updatedMeta2 = await updateAutoTitleFlagMetaValuesHandler(
    mode,
    docId,
    "should_update_title",
    false,
  );
  dispatch({
    type: action,
    payload: updatedMeta2,
  });
};

export const updateAutoTitleFlagMetaValues =
  (mode, docId, key, isSet) => async dispatch => {
    const updatedMeta = await updateAutoTitleFlagMetaValuesHandler(
      mode,
      docId,
      key,
      isSet,
    );
    const action =
      mode === DOCUMENT_MODE.TEMPLATE
        ? "UPDATE_TEMPLATE_META"
        : "UPDATE_DOCUMENT_META";
    dispatch({
      type: action,
      payload: updatedMeta,
    });
  };

export const updateComponentSignerId =
  (mode, docID, componentId, signerId) => dispatch => {
    const { components } = store.getState().DocumentStore;
    const component = components[componentId];
    const section = component.content;
    const sigConfig = {
      id: 1,
      tag_type: "",
      component_id: componentId,
      signer_identity_id: signerId,
      signer_config: {
        image_url: "",
        options: [
          {
            checked: true,
            id: "signature",
            label: "Signature",
            value: "",
            width: 200,
            height: 60,
          },
        ],
        point: {},
        signature_type: "FULLNAME",
      },
    };
    section.data = sigConfig;
    const updateMethod = updateSection(mode);
    updateMethod(section).then(comp => {
      dispatch(updateDocumentComponentAction(comp));
      dispatch(updateDocSignatoryActionV2(docID, [sigConfig]));
    });
  };

export const updateBlockchainMetaData = payload => dispatch => {
  dispatch({
    type: "UPDATE_BLOCKCHAIN_META_DATA",
    payload,
  });
};

export const convertFormDocToEditorDoc = docID => dispatch =>
  new Promise((resolve, reject) => {
    convertFormDoctoEditor(docID)
      .then(response => {
        dispatch({
          type: "UPDATE_FORM_DOC_TYPE_TO_EDITOR",
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const saveTempPastedImage = (file, sectionID) => dispatch => {
  dispatch({
    type: "SAVE_TEMP_PASTED_IMAGE",
    payload: {
      file,
      sectionID,
    },
  });
};

export const updateSignerTvalues = mode => {
  if (mode === DOCUMENT_MODE.DOCUMENT) return updateDocSignatoryActionV2;
  if (mode === DOCUMENT_MODE.TEMPLATE) return updateTemplateSignatoryActionV2;
  return () => {};
};

export const updateSignerTagValues =
  (mode, documentID, componentID, tag_type, tag_value) => dispatch => {
    const {
      document: { signatoriesV2: signatories = [] },
    } = store.getState().DocumentStore;
    for (let i = 0; i < signatories.length; i += 1) {
      const { tags = [] } = signatories[i];
      const tag = tags.find(t => t.component_id === componentID);
      if (tag) {
        const { signer_config = {} } = tag;
        const payload = [
          {
            ...tag,
            signer_config: {
              ...signer_config,
              tag_value,
            },
          },
        ];
        dispatch(updateSignerTvalues(mode)(documentID, payload));
        break;
      }
    }
  };
